import { Component, inject, input, output, HostListener } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { CredentialsService } from '@core/utils';

@Component({
  selector: 'app-header, [app-header]',
  standalone: true,
  imports: [NgbDropdownModule, RouterLink, TitleCasePipe],
  templateUrl: './header.component.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private readonly router = inject(Router);
  private readonly credentialsService = inject(CredentialsService);
  readonly credentials = this.credentialsService.credentials;

  fechaActual: Date = new Date();

  mobileView = 1536;

  isMobile = this.getWidth() < this.mobileView;

  isSidebarOpen = input.required<boolean>();
  handleToggle = output<boolean>();

  changeSidebarStatus() {
    this.handleToggle.emit(!this.isSidebarOpen());
  }

  logout() {
    this.credentialsService.setCredentials();
    this.router.navigateByUrl('/login');
  }

  primeraLetra(texto: string | undefined): string {
    if (!texto) {
      return '-';
    }
    return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
  }

  obtenerFechaFormateada(): string {
    const opciones: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    };
    const fechaFormateada = new Intl.DateTimeFormat('es-ES', opciones).format(this.fechaActual);
    return fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
  }

  getWidth() {
    return window.innerWidth;
  }

  @HostListener('window:resize', [])
  onResize() {
    this.isMobile = this.getWidth() < this.mobileView;
  }
}
